/* eslint-disable consistent-return,react-hooks/exhaustive-deps,arrow-body-style */
import React, { useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Select,
  Tooltip,
  Row,
  Col,
  Form,
  Modal,
  Divider,
  Typography,
  Input,
} from "antd";
import find from "lodash/find";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import moment from "moment";
import { useHistory } from "react-router-dom";
import {
  displayFormat,
  toDisplayFormat,
  toHttpFormat,
  toHttpFormatStartOfDay,
} from "../../lib/utils/formatDate";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { urlFormValidator } from "../../lib/utils/urlFormValidator";
import HistoryAndPropertyModal from "../HistoryAndPropertyModal/HistoryAndPropertyModal";
import { ReactComponent as DotsIcon } from "../../img/3dots.svg";
import {
  fetchAgreementByAgrId,
  fetchAgreementVersions,
  fetchGetAgreementsByAccId,
  updateAgreementVersions,
} from "../../store/slices/agreements";
import "./AccountAgreements.less";

// const { Link } = Typography;

import tickIcon from "../../img/done.svg";
import deleteIcon from "../../img/delete-round.svg";
import pencilWithPlusIcon from "../../img/pencil-plus.svg";
import edit from "../../img/edit.svg";
import { hasAccess } from "../RolesModule/hasAccess";
import {
  AGREEMENT_CREATE,
  MENU_ACCOUNT_AGREEMENT_WRITE,
  MENU_TC_ACCOUNT_AGREEMENT_TARIFF,
} from "../../lib/const/permissions";
import warningIcon from "../../img/warning";
import ToggleableVersionsTable from "../ToggleableVersionsTable/ToggleableVersionsTable";
import versionsTableUtils from "../../lib/utils/versionsTableUtils";
import { limitText } from "../../lib/utils/limitText";
import MultipleSelect from "../common/MultipleSelect";
import agreementStatusCodes from "../../lib/const/agreementStatusCodes";
import { searchIconForInput } from "../../lib/icons";
import { getBlockingStatusIcon } from "../../lib/utils/getBlockingStatusIcon";
import BlockingModal from "../BlockingModal/BlockingModal";
import { BlockingObjTypes } from "../../lib/const/blockingObjTypes";
import useBlockingMode from "../../lib/hooks/useBlockingMode";

const AccountAgreements = () => {
  const dispatch = useDispatch();
  const { accountId } = useParams();
  const dateNowParse = toHttpFormat(moment());
  const history = useHistory();
  const [form] = Form.useForm();

  const { account } = useSelector((state) => state.accounts);

  const accountName = account.individual
    ? [account.individual?.lastName, account.individual?.firstName, account.individual?.middleName]
        .filter(Boolean)
        .join(" ")
    : account.organization?.fullName;

  const isBlockingMode = useBlockingMode();

  const {
    agreement,
    agreements,
    agreementsLoading,
    agreementsVersions,
    agreementsVersionsLoading,
  } = useSelector((state) => state.agreements);
  const { agrStatus, agrStatusLoading, products } = useSelector((state) => state.rtkDictionaries);
  const [object, setObject] = useState("");
  const [editingKey, setEditingKey] = useState(null);
  const [formCurrencyEditStatus, setFormCurrencyEditStatus] = useState("idle");
  const [dataVersion, setDataVersion] = useState("");
  const [agreeemntVersionId, setAgreementVersionId] = useState(null);
  const [agreementRequestBody, setAgreementRequestBody] = useState("");
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const isEditing = (rec) => rec.key === editingKey;
  const isEditingToDate = formCurrencyEditStatus === "editingToDate";
  const isEditingVersion = formCurrencyEditStatus === "editing";
  const isMakingNewVersion = formCurrencyEditStatus === "createNewVersion";
  const dateFormat = displayFormat;

  const [filterAgreementsIdsForm] = Form.useForm();
  const [activeIds, setActiveIds] = useState([]);

  const { Option } = Select;

  const handleShowModal = (objId) => {
    setObject(objId);
  };

  const handleHideModal = () => {
    setObject("");
  };

  const [objectBlockingId, setObjectBlockingId] = useState("");

  const handleShowBlockingModal = (objId) => {
    setObjectBlockingId(objId);
  };

  const handleHideBlockingModal = () => {
    setObjectBlockingId("");
  };

  const handleTerminCreateForm = () => {
    history.push(`/accounts/${accountId}/agreements/create`);
  };

  useEffect(() => {
    setAgreementRequestBody(agreement);
  }, [agreement]);

  useEffect(() => {
    setSelectedStatuses(
      agrStatus &&
        agrStatus
          ?.filter((item) => item.id !== agreementStatusCodes.DELETED_ARCHIVED)
          ?.map((item) => item?.id)
    );
  }, [agrStatus]);

  useEffect(() => {
    setDataVersion(
      agreementsVersions &&
        agreementsVersions?.map((item, index) => ({
          key: String(`${index}prop`),
          id: item.id,
          agreementNumber: item.agreementNumber,
          validFrom: item.validFrom,
          validTo: item.validTo,
          period: item,
          agreementDate: item.agreementDate,
          agreementStatusId: item.agreementStatusId,
          fromDateValue: item.fromDate,
          toDateValue: item.toDate,
          isCurrentVersion: moment().isBetween(item.fromDate, item.toDate),
          isPastVersion: moment(item.fromDate).isBefore(dateNowParse),
          isFutureVersion: moment(item.fromDate).isAfter(dateNowParse),
          lastVersion: String(index) === String(0) ? "lastVersion" : "",
          productId: item.productId,
        }))
    );
  }, [agrStatus, agreementsVersions]);

  const getWarningModal = () => {
    Modal.error({
      okButtonProps: {
        style: {
          marginLeft: "auto",
          marginRight: "auto",
          width: "108px",
        },
      },
      content: (
        <>
          <div
            style={{
              display: "flex",
              height: "100px",
              margin: "15px auto",
              width: "550px",
            }}
          >
            <div style={{ marginTop: "5px" }}>{warningIcon}</div>
            <div
              style={{
                marginLeft: "24px",
                fontSize: "16px",
                width: "506px",
              }}
            >
              Вы меняете Продукт договора.
              <br />
              Пожалуйста, проверьте продукты, подключенные для договора,
              <br />и отключите те, что не соответствуют Продукту.
            </div>
          </div>
          <Divider style={{ margin: 0 }} />
        </>
      ),
      icon: null,
      width: 600,
    });
  };

  const columnsWidths = {
    ...versionsTableUtils.columnsWidths,
    id: "6vw",
    agreementNumber: "8vw",
    productId: "7vw",
    period: "9vw",
    validFrom: "7vw",
    validTo: "7vw",
    agreementDate: "7vw",
    agreementStatusId: "10vw",
    uri: "10vw",
    actions: "5vw",
    buttons: "2vw",
    blockingIco: "1vw",
  };

  const getDefaultFromDate = (fromDateValue) => {
    const startOfMonth = moment().startOf("month");
    const recordFromDate = moment(fromDateValue);
    if (recordFromDate.isBefore(startOfMonth)) return startOfMonth;
    return recordFromDate;
  };

  const renderIdTitle = () => {
    const notValidRgx = /[^0-9,]/;
    let valueTrim = "";
    const onChangeId = ({ target: { value } }) => {
      valueTrim = value.replace(/^\s+/g, "");
      filterAgreementsIdsForm.setFieldsValue({ ids: valueTrim });
      if (!notValidRgx.test(value)) {
        const activeIdes = valueTrim?.split(/\D/).filter(Boolean).map(Number);
        setActiveIds(activeIdes);
      }
    };

    return (
      <Tooltip title="Введите ID договоров через ','">
        <Form form={filterAgreementsIdsForm}>
          <Form.Item
            name="ids"
            style={{ marginBottom: 0 }}
            className="form-item-required__hidden-error__mb0"
            rules={[
              {
                validator: (x, value) => {
                  if (value && /[^0-9,]/.test(value)) {
                    return Promise.reject();
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              aria-autocomplete="none"
              placeholder="ID договоров"
              allowClear
              className="table-head-filter-search"
              suffix={searchIconForInput()}
              onChange={onChangeId}
            />
          </Form.Item>
        </Form>
      </Tooltip>
    );
  };

  renderIdTitle.toString = () => "ID договора";

  const getColumnsInner = () =>
    [
      {
        title: "ID договора",
        dataIndex: "id",
        key: "id",
        width: columnsWidths.id,
        hidden: true,
      },
      {
        title: "Номер договора",
        dataIndex: "agreementNumber",
        key: "agreementNumber",
        width: columnsWidths.agreementNumber,
      },
      {
        title: "",
        dataIndex: "blockingStatus",
        key: "blockingStatus",
        width: columnsWidths.blockingIco,
        render: (_) => <div>{getBlockingStatusIcon(undefined)}</div>,
      },
      {
        title: "Продукт",
        dataIndex: "productId",
        key: "productId",
        width: columnsWidths.productId,
        render: (productId, record) => {
          const editable = isEditing(record);
          if (!editable || isEditingToDate)
            return products.find(({ id }) => id === productId)?.name;
          if (isEditingVersion || isMakingNewVersion) {
            const onChange = (value) => {
              getWarningModal();
              setAgreementRequestBody({
                ...agreementRequestBody,
                productId: value,
              });
            };
            return (
              <Form.Item
                className="form-item-required__hidden-error__mb0"
                initialValue={productId}
                name="productId"
              >
                <Select style={{ width: "100%" }} onChange={onChange}>
                  {products &&
                    products.length !== 0 &&
                    products.map((item) => (
                      <Option key={item.id} value={item.id}>
                        <Tooltip title={item.name}>{limitText(item.name, 10)}</Tooltip>
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            );
          }
        },
      },
      {
        title: "Период действия",
        dataIndex: "period",
        key: "period",
        width: columnsWidths.period,
        render: (val, record) => {
          const editable = isEditing(record);

          const onChangeFromDate = (e) => {
            setAgreementRequestBody({
              ...agreementRequestBody,
              fromDate: toHttpFormatStartOfDay(e),
            });
          };

          const disabledDates = (current) =>
            current.isBefore(moment(record.fromDateValue).startOf("day")) ||
            current.isAfter(moment(record.toDateValue));

          return editable && isMakingNewVersion ? (
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <Form.Item
                name="fromDate"
                className="form-item-required__hidden-error__mb0"
                rules={[
                  {
                    required: true,
                  },
                ]}
                initialValue={getDefaultFromDate(record.fromDateValue)}
              >
                <DatePicker
                  format={dateFormat}
                  onChange={onChangeFromDate}
                  disabledDate={disabledDates}
                  style={{ width: "115px" }}
                  allowClear={false}
                />
              </Form.Item>
              <Form.Item className="form-item-required__hidden-error__mb0">
                - {record.toDateValue ? toDisplayFormat(record.toDateValue) : ""}
              </Form.Item>
            </div>
          ) : (
            <>
              {record.fromDateValue ? toDisplayFormat(record.fromDateValue) : ""} -{" "}
              {record.toDateValue ? toDisplayFormat(record.toDateValue) : ""}
            </>
          );
        },
      },
      {
        title: "Действителен с",
        dataIndex: "validFrom",
        key: "validFrom",
        width: columnsWidths.validFrom,
        render: (value, record) => {
          const editable = isEditing(record);
          if (editable && isMakingNewVersion) {
            return (
              <Form.Item
                className="form-item-required__hidden-error__mb0"
                initialValue={moment(value, "YYYY-MM-DD")}
                name="validFrom"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker format={dateFormat} />
              </Form.Item>
            );
          }
          return value ? toDisplayFormat(value) : "";
        },
      },
      {
        title: "Действителен по",
        dataIndex: "validTo",
        key: "validTo",
        width: columnsWidths.validTo,
        render: (value, record) => {
          const editable = isEditing(record);
          if (editable && isMakingNewVersion) {
            return (
              <Form.Item
                className="form-item-required__hidden-error__mb0"
                initialValue={moment(value, "YYYY-MM-DD")}
                name="validTo"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker format={dateFormat} />
              </Form.Item>
            );
          }
          return value ? toDisplayFormat(value) : "";
        },
      },
      {
        title: "Дата договора",
        dataIndex: "agreementDate",
        key: "agreementDate",
        width: columnsWidths.agreementDate,
        render: (value, record) => {
          const editable = isEditing(record);
          if (editable && isMakingNewVersion) {
            return (
              <Form.Item
                className="form-item-required__hidden-error__mb0"
                initialValue={moment(value, "YYYY-MM-DD")}
                name="agreementDate"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker format={dateFormat} />
              </Form.Item>
            );
          }
          return value ? toDisplayFormat(value) : "";
        },
      },
      {
        title: "Статус",
        dataIndex: "agreementStatusId",
        key: "agreementStatusId",
        width: columnsWidths.agreementStatusId,
        render: (val, record) => {
          const editable = isEditing(record);

          const onChange = (value) => {
            setAgreementRequestBody({
              ...agreementRequestBody,
              agreementStatusId: value,
            });
          };

          return editable && (isMakingNewVersion || isEditingVersion) ? (
            <>
              <Form.Item
                className="form-item-required__hidden-error__mb0"
                initialValue={val}
                name="agreementStatusId"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select style={{ width: "100%" }} onChange={onChange}>
                  {checkIsLoaded(agrStatusLoading) &&
                    agrStatus.map((item) => (
                      <Option key={item.id} value={item.id}>
                        <Tooltip title={item.name}>{limitText(item.name, 10)}</Tooltip>
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </>
          ) : (
            <>{find(agrStatus, { id: val })?.name}</>
          );
        },
      },
      {
        title: "Ссылка на договор",
        dataIndex: "uri",
        key: "uri",
        width: columnsWidths.uri,
        render: (val, record) => {
          const editable = isEditing(record);
          if (editable && (isMakingNewVersion || isEditingVersion)) {
            return (
              <Tooltip title="Ссылка на договор">
                <Form.Item
                  className="form-item-required__hidden-error__mb0"
                  initialValue={val}
                  name="uri"
                  rules={[
                    {
                      validator: (_, value) => urlFormValidator(value),
                      message: "Введен недопустимый формат ссылки на договор",
                    },
                  ]}
                >
                  <Input placeholder="http://" />
                </Form.Item>
              </Tooltip>
            );
          }
          if (val) {
            return (
              <Tooltip title={val}>
                <Typography.Link href={val} target="_blank">
                  Договор
                </Typography.Link>
              </Tooltip>
            );
          }
          return null;
        },
      },
      {
        title: "",
        dataIndex: "",
        key: "x",
        render: (val, record, index) => {
          if (hasAccess(MENU_ACCOUNT_AGREEMENT_WRITE)) {
            const editable = isEditing(record);
            const disabled = isMakingNewVersion || isEditingToDate || isEditingVersion;

            const statusValue = val.agreementStatusId;
            const fromDateVal = val.fromDateValue;

            const handleEdit = () => {
              form.resetFields();
              setAgreementRequestBody({
                ...agreementRequestBody,
                fromDate: fromDateVal,
                agreementStatusId: statusValue,
              });

              setEditingKey(record.key);
              setFormCurrencyEditStatus("editing");
            };

            const addNewVersion = () => {
              form.resetFields();
              setAgreementRequestBody({
                ...agreementRequestBody,
                productId: record.productId,
                fromDate: getDefaultFromDate(record.fromDateValue),
                validFrom: record.validFrom,
                validTo: record.validTo,
                agreementDate: record.agreementDate,
                agreementStatusId: record.agreementStatusId,
              });

              setEditingKey(`new${record.key}`);
              setFormCurrencyEditStatus("createNewVersion");

              const newRecord = {
                ...dataVersion[index],
                key: `new${dataVersion[index].key}`,
              };

              setDataVersion((prev) => [...prev.slice(0, index), newRecord, ...prev.slice(index)]);
            };

            const handleCancel = () => {
              form.resetFields();
              setEditingKey(null);
              if (isMakingNewVersion)
                setDataVersion((prev) => [...prev.slice(0, index), ...prev.slice(index + 1)]);

              setFormCurrencyEditStatus("idle");

              setAgreementRequestBody({
                ...agreementRequestBody,
                agreementStatusId: null,
                fromDate: null,
              });
            };

            const handleSubmit = () => {
              form.validateFields().then(async () => {
                const formValues = form.getFieldsValue();
                if (isMakingNewVersion) {
                  const fromDate = moment(record.fromDateValue).isSame(
                    agreementRequestBody.fromDate,
                    "day"
                  )
                    ? toHttpFormat(moment(record.fromDateValue).add(2, "seconds"))
                    : toHttpFormatStartOfDay(agreementRequestBody.fromDate);

                  const dataCreate = {
                    ...agreementRequestBody,
                    agreementStatusId: agreementRequestBody.agreementStatusId,
                    fromDate,
                    uri: formValues.uri,
                    validFrom: formValues.validFrom.format("YYYY-MM-DD"),
                    validTo: formValues.validTo.format("YYYY-MM-DD"),
                    agreementDate: formValues.agreementDate.format("YYYY-MM-DD"),
                  };
                  // return console.log(dataCreate);
                  await dispatch(
                    updateAgreementVersions({
                      id: record.id,
                      fromDate,
                      force: false,
                      values: dataCreate,
                    })
                  );
                }
                if (isEditingVersion) {
                  const dataUpdate = {
                    ...agreementRequestBody,
                    uri: formValues.uri,
                    agreementStatusId: agreementRequestBody.agreementStatusId,
                  };
                  // return console.log(dataUpdate);
                  await dispatch(
                    updateAgreementVersions({
                      id: record.id,
                      fromDate: record.fromDateValue,
                      force: true,
                      values: dataUpdate,
                    })
                  );
                }

                await dispatch(fetchGetAgreementsByAccId({ accId: accountId }));
                await dispatch(
                  fetchAgreementVersions({
                    agreementId: agreeemntVersionId,
                  })
                );

                setEditingKey(null);
                setFormCurrencyEditStatus("idle");
                form.resetFields();
              });
            };

            return editable ? (
              <div style={{ display: "flex", flexWrap: "noWrap", justifyContent: "flex-end" }}>
                <Tooltip title="Подтвердить">
                  <Button
                    icon={<img src={tickIcon} alt="tick" width="16px" />}
                    className="button-icon"
                    type="text"
                    htmlType="submit"
                    onClick={handleSubmit}
                  />
                </Tooltip>
                <Tooltip title="Отменить">
                  <Button
                    icon={<img src={deleteIcon} width="16px" alt="delete" />}
                    className="button-icon"
                    type="text"
                    htmlType="button"
                    onClick={handleCancel}
                  />
                </Tooltip>
              </div>
            ) : (
              <div style={{ display: "flex", flexWrap: "noWrap", justifyContent: "flex-end" }}>
                <Tooltip title="Добавить версию">
                  {(record.isFutureVersion || record.isCurrentVersion) && (
                    <Button
                      icon={<img src={pencilWithPlusIcon} alt="pencil with plus" width="16px" />}
                      className="button-icon"
                      type="text"
                      htmlType="button"
                      onClick={addNewVersion}
                      disabled={disabled}
                    />
                  )}
                </Tooltip>
                <Tooltip title="Редактировать версию">
                  {(record.isFutureVersion || record.isCurrentVersion) && (
                    <Button
                      icon={<img src={edit} alt="pencil" width="16px" />}
                      className="button-icon"
                      type="text"
                      htmlType="button"
                      disabled={disabled}
                      onClick={handleEdit}
                    />
                  )}
                </Tooltip>
              </div>
            );
          }
        },
        width: columnsWidths.actions,
      },
      {
        title: "",
        dataIndex: "",
        key: "x",
        width: columnsWidths.buttons,
        render: (record) => (
          <div className="dots-wrapper">
            <Button
              onClick={(e) => {
                e.stopPropagation();
                handleShowModal(record);
              }}
              className="button-icon iconButton"
              style={{ outline: "none" }}
              icon={<DotsIcon />}
            />
          </div>
        ),
      },
    ].filter((el) => {
      return !(el.key === "blockingStatus" && !isBlockingMode);
    });

  const [columnsInner, setColumnsInner] = useState(getColumnsInner());

  useEffect(() => {
    setColumnsInner((prev) => {
      const newColumns = getColumnsInner().map((column, i) => ({
        ...column,
        hidden: prev[i]?.hidden,
      }));
      return newColumns;
    });
  }, [dataVersion, editingKey, agreementRequestBody, formCurrencyEditStatus]);

  const agreementData =
    checkIsLoaded(agreementsLoading) &&
    agreements
      .map((acc, idx) => ({
        key: `${acc.id}&${idx}`,
        id: acc.id,
        agreementNumber: acc.agreementNumber,
        validFrom: acc.validFrom,
        validTo: acc.validTo,
        period: acc,
        agreementDate: acc.agreementDate,
        agreementStatusId: acc.agreementStatusId,
        uri: acc.uri,
        fromDateValue: acc.fromDate,
        toDateValue: acc.toDate,
        productId: acc.productId,
        blockingStatus: acc?.blockingStatus,
        accountId: acc.accountId,
      }))
      .filter(({ agreementStatusId }) => {
        if (selectedStatuses.length === 0) {
          return true;
        }
        return selectedStatuses.includes(agreementStatusId);
      })
      .filter(({ id }) => {
        if (activeIds.length === 0) {
          return true;
        }
        return activeIds.some((activeId) => String(id).startsWith(String(activeId)));
      });

  const renderStatusIdTitle = () => (
    <MultipleSelect
      onChange={setSelectedStatuses}
      value={selectedStatuses}
      allValues={agrStatus?.map(({ id }) => id) || []}
      placeholder="Статус"
      style={{ width: "100%" }}
      allowClear
      maxTagCount={1}
      showSearch
      filterOption={(inputValue, { children }) =>
        children.toLowerCase().includes(inputValue.toLowerCase())
      }
    >
      {agrStatus.map(({ id, name }) => (
        <Select.Option key={id} value={id}>
          {name}
        </Select.Option>
      ))}
    </MultipleSelect>
  );

  renderStatusIdTitle.toString = () => "Статус";

  const getColumns = () =>
    [
      {
        title: renderIdTitle,
        dataIndex: "id",
        key: "id",
        width: columnsWidths.id,
        hidden: true,
      },
      {
        title: "Номер договора",
        dataIndex: "agreementNumber",
        key: "agreementNumber",
        width: columnsWidths.agreementNumber,
        sorter: (a, b) => {
          return a.agreementNumber > b.agreementNumber ? 1 : -1;
        },
      },
      {
        title: "",
        dataIndex: "blockingStatus",
        key: "blockingStatus",
        width: columnsWidths.blockingIco,
        render: (blockingStatus, record) => (
          <div>{getBlockingStatusIcon(blockingStatus, () => handleShowBlockingModal(record))}</div>
        ),
      },
      {
        title: "Продукт",
        dataIndex: "productId",
        key: "productId",
        render: (productId) => products.find(({ id }) => id === productId)?.name,
        width: columnsWidths.productId,
      },
      {
        title: "Период действия",
        dataIndex: "period",
        key: "period",
        width: columnsWidths.period,
        render: (record) =>
          `${record.fromDate ? toDisplayFormat(record.fromDate) : ""} - ${
            record.toDate ? toDisplayFormat(record.toDate) : ""
          }`,
      },
      {
        title: "Действителен с",
        dataIndex: "validFrom",
        key: "validFrom",
        width: columnsWidths.validFrom,
        render: (validFrom) => (validFrom ? toDisplayFormat(validFrom) : ""),
      },
      {
        title: "Действителен по",
        dataIndex: "validTo",
        key: "validTo",
        width: columnsWidths.validTo,
        render: (validTo) => (validTo ? toDisplayFormat(validTo) : ""),
      },
      {
        title: "Дата договора",
        dataIndex: "agreementDate",
        key: "agreementDate",
        width: columnsWidths.agreementDate,
        defaultSortOrder: "descend",
        render: (agreementDate) => (agreementDate ? toDisplayFormat(agreementDate) : ""),
        sorter: (a, b) => {
          return (
            moment(a.agreementDate, "YYYY-MM-DD").unix() -
            moment(b.agreementDate, "YYYY-MM-DD").unix()
          );
        },
      },
      {
        title: renderStatusIdTitle,
        dataIndex: "agreementStatusId",
        key: "agreementStatusId",
        width: columnsWidths.agreementStatusId,
        render: (val) => {
          return <> {find(agrStatus, { id: val })?.name}</>;
        },
      },
      {
        title: "Ссылка на договор",
        dataIndex: "uri",
        key: "uri",
        width: columnsWidths.uri,
        render: (val) => {
          if (val) {
            const valFormat =
              String(val)?.includes("https://") || String(val)?.includes("http://")
                ? val
                : `https://${val}`;
            return (
              <Tooltip title={valFormat}>
                <Typography.Link href={valFormat} target="_blank">
                  Договор
                </Typography.Link>
              </Tooltip>
            );
          }
          return null;
        },
      },
      {
        title: "",
        width: columnsWidths.actions,
        key: "actions",
      },
      {
        title: "",
        dataIndex: "",
        key: "x",
        render: (record) => (
          <div className="dots-wrapper">
            <Button
              onClick={(e) => {
                e.stopPropagation();
                handleShowModal(record);
              }}
              className="button-icon iconButton"
              style={{ outline: "none" }}
              icon={<DotsIcon />}
            />
          </div>
        ),
        width: columnsWidths.buttons,
      },
    ].filter((el) => {
      return !(el.key === "blockingStatus" && !isBlockingMode);
    });

  const [columns, setColumns] = useState(getColumns());

  useEffect(() => {
    setColumns((prev) => {
      const newColumns = getColumns().map((column, i) => ({
        ...column,
        hidden: prev[i]?.hidden,
      }));
      return newColumns;
    });
  }, [products, agrStatus, selectedStatuses, isBlockingMode]);

  const onRow = (record) => ({
    onClick: () => {
      if (hasAccess(MENU_TC_ACCOUNT_AGREEMENT_TARIFF, MENU_TC_ACCOUNT_AGREEMENT_TARIFF)) {
        history.push(`/accounts/${accountId}/agreements/${record.id}/tariffs`);
      }
    },
  });

  // TODO Александр. Нужно сделать hasAccess корректно (если несколько вариантов доступа, они передаются массивом)
  return (
    <>
      <Row align="middle" justify="space-between">
        <h1>Договоры аккаунта</h1>
        {hasAccess(AGREEMENT_CREATE) && hasAccess(MENU_ACCOUNT_AGREEMENT_WRITE) && (
          <Col>
            <Button onClick={handleTerminCreateForm} type="primary">
              Создать договор
            </Button>
          </Col>
        )}
      </Row>

      <Form form={form} className="account-agreements">
        <ToggleableVersionsTable
          tableClassName="version-table"
          tableName="account-agreements"
          columns={columns}
          tableData={agreementData}
          childTableColumns={columnsInner}
          childTableData={dataVersion}
          isChildTableLoading={checkIsLoading(agreementsVersionsLoading)}
          setColumns={setColumns}
          setChildTableColumns={setColumnsInner}
          onRow={onRow}
          onOpenVersionsCallback={(record, expanded) => {
            setDataVersion("");
            if (!expanded) {
              setAgreementVersionId(record.id);
              setFormCurrencyEditStatus("idle");
              setEditingKey(null);
              dispatch(fetchAgreementByAgrId({ agreementId: record.id }));
              dispatch(
                fetchAgreementVersions({
                  agreementId: record.id,
                })
              );
            }
          }}
          scroll={{ x: true }}
          isPaginable={{ position: ["bottomCenter"], hideOnSinglePage: true }}
        />
      </Form>

      <HistoryAndPropertyModal
        objectTypeSysname="agreement"
        objectId={object?.id}
        handleHideModal={handleHideModal}
        visibleModal={object?.id}
        dateObjectFromForCalendar={object?.fromDateValue}
        dateObjectToForCalendar={object?.toDateValue}
        hasAccessToEdit={hasAccess(MENU_ACCOUNT_AGREEMENT_WRITE)}
      />

      <BlockingModal
        objectTypeId={BlockingObjTypes.Договор}
        objectId={objectBlockingId?.id}
        handleHideModal={handleHideBlockingModal}
        visibleModal={objectBlockingId?.id}
        agreementAccountId={objectBlockingId?.accountId || accountId}
        agreementNumber={objectBlockingId?.agreementNumber}
        accountName={accountName}
        onSuccessRequest={() => {
          dispatch(fetchGetAgreementsByAccId({ accId: accountId }));
        }}
      />
    </>
  );
};

export default AccountAgreements;
